import Button from "@material-ui/core/Button";
import Dialog from "@material-ui/core/Dialog";
import DialogActions from "@material-ui/core/DialogActions";
import DialogContent from "@material-ui/core/DialogContent";
import DialogContentText from "@material-ui/core/DialogContentText";
import DialogTitle from "@material-ui/core/DialogTitle";
import { useMutation, useNotify } from "ra-core";
import React from "react";
import { Booking } from "../../types";

interface Props {
  data: Booking;
}

const CancelReportDialog: React.FC<Props> = ({ data }) => {
  const [open, setOpen] = React.useState(false);
  const notify = useNotify();

  const [handleCancelReport, { loading }] = useMutation(
    {
      type: "update",
      resource: "bookings",
      payload: {
        id: data.id ?? "",
        data: {
          action: "cancel_report",
        },
      },
    },
    {
      onSuccess: () => {
        notify(`Report has been cancelled.`, "info");
        setOpen(false);
      },
      onFailure: (error) => notify(`Error: ${error.message}`, "warning"),
    }
  );

  const handleClickOpen = () => {
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
  };

  return (
    <>
      <Button
        style={{ marginLeft: 10 }}
        color="secondary"
        onClick={handleClickOpen}
        size={"small"}
        variant="contained"
        disabled={loading}
      >
        Cancel Report
      </Button>
      <Dialog open={open} onClose={handleClose}>
        <DialogTitle id="alert-dialog-title">Cancel Report</DialogTitle>
        <DialogContent>
          <DialogContentText id="alert-dialog-description">
            Are you sure you want to cancel the report for this booking?
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button onClick={handleClose} color="secondary">
            Back
          </Button>
          <Button
            onClick={handleCancelReport}
            color="primary"
            autoFocus
            disabled={loading}
          >
            Confirm
          </Button>
        </DialogActions>
      </Dialog>
    </>
  );
};

export default CancelReportDialog;
